module.exports = __webpack_public_path__ + "static/profile-a8786843da5b060e19a3c867009f874d.png";